module.exports = __webpack_public_path__ + "static/portfolio-image-6-09e39ecf0d801a8c981790bd77d605a3.jpg";